import { Box, FormControl, MenuItem, Select } from '@mui/material'
import { useContext } from 'react'
import Context from '../../Context'

function Bookmakers() {
  const { selectedBookmaker, setSelectedBookmaker } = useContext(Context)

  const handleChange = (event) => {
    setSelectedBookmaker(event.target.value)
    console.log(event.target.value)
  }

  return(
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <FormControl fullWidth sx={{ width: '90%', mx: 'auto', backgroundColor: 'transparent', color: 'white' }}>
        <Select
          labelId="select-label"
          id="select"
          label="Bookmaker"
          value={selectedBookmaker}
          onChange={handleChange}
          sx={{
            width: '100%',
            backgroundColor: 'white',
            height: '35px',
            ".MuiOutlinedInput-input": {
              padding: '10px 14px',
            },
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: 'white'
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: 'white'
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: 'white'
            }
          }}
        >
          <MenuItem value={'Bovada'} sx={{ height: 'auto', padding: '4px 10px' }}>Bovada</MenuItem>
        </Select>
      </FormControl>
    </Box>
  )
}

export default Bookmakers